let isProxy = null;
let isKey = null;
let loadSection = false;

    console.log('faceage dddx');
(function () {
  function initFaceAge() {
    console.log('faceage init');

    let faceAgeInterval = setInterval(function () {
      if (window.FaceAge) {
        clearInterval(faceAgeInterval);

        let module = document.getElementById('faceAge-module');
        if (module && !window.loadSection) {
          window.loadSection = true;

          let isKey = module.getAttribute('data-key');
          console.log('faceage key', isKey);

          let isProxy = module.getAttribute('data-proxy');

          let loadingSt = module.querySelector('.loading_request_face');
          if (loadingSt) loadingSt.remove();

          renderFaceAge(module);
        }

        let moduleEmbed = document.getElementById('faceAge-module-embed');
        if (moduleEmbed) {
          renderFaceAge(moduleEmbed);
        }
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaceAge);
  } else {
    initFaceAge();
  }
})();


function renderFaceAge(module) {

  if (window.FaceAge) {

    const shopify_urls = [Shopify.shop, window.location.hostname];

    const currencyCode = Shopify?.currency?.active;
    const currencySymbol = currencySymbols[currencyCode] || currencyCode;

    let problems = [];
    let routinesSupport = [];
    let importSelected = 'all';
    let displayFeaturesSelected = null;
    let displayPurchaseButton = true;
    let displaySelected = null;
    let privacyUrl = null;
    let gtag = module.getAttribute('data-gtm');
    let settings = module.getAttribute('data-config');
    let minHeight = module.getAttribute('data-height');
    let displayModel = module.getAttribute('data-type') || 'modal';

    if(settings) {
      settings = JSON.parse(settings);
      settings = settings.data;

      if(settings?.problems)
        problems = settings.problems.split(',');

      if(settings?.privacyUrl)
        privacyUrl = settings.privacyUrl;

      if(settings?.routinesSupport)
        routinesSupport = settings.routinesSupport.split(',');

      if(settings?.importSelected)
        importSelected = settings.importSelected;

      if(settings?.displayPurchaseButton !== undefined )
        displayPurchaseButton = settings.displayPurchaseButton !== 'false';

      if(settings?.displayFeaturesSelected)
        displayFeaturesSelected = settings.displayFeaturesSelected.split(',');

      if(settings?.displaySelected)
        displaySelected = settings.displaySelected.split(',');

      //console.log("settings", settings);
    }


    const options = {
      faceageId: module.getAttribute('data-key'),
      displayModel: displayModel,
      showProducts: (displayFeaturesSelected ? (displayFeaturesSelected.indexOf('show_products') !== -1) : true),
      showRoutine: (displayFeaturesSelected ? (displayFeaturesSelected.indexOf('show_routine') !== -1) : true),
      quiz: (displayFeaturesSelected ? (displayFeaturesSelected.indexOf('show_quiz') !== -1) : true),
      showCamera: (importSelected !== 'all' ? (importSelected === 'camera') : true),
      showUpload: (importSelected !== 'all' ? (importSelected === 'upload') : true),
      showUpload: (importSelected !== 'all' ? (importSelected === 'upload') : true),
      language: Shopify?.locale || 'en',
      currency: currencySymbol || "$",
      privacyUrl: privacyUrl || "",
      showAddToCard: displayPurchaseButton,
      showAddToCardAll: true,
      messageSticky: true,
    };

    if(displayModel && displayModel === 'section')
      options.elementId = 'faceAge-module';

    if(problems && problems.length > 0)
      options.problems = problems;

    if (gtag && gtag.length > 0){

      if (!window.dataLayer) {
        window.dataLayer = [];
      }

      options.gtagInsert = false;
      options.gtag = gtag;
      options.gtagDataLayer = window.dataLayer;
    }

    /*if(routinesSupport && routinesSupport.length > 0)
      options.routinesSupport = routinesSupport;*/

    if(minHeight)
      options.height = minHeight + 'px';



    console.log('FaceAge module is loading script...');
    const faceAge = new FaceAge(options);
    faceAge.render();

    // Define callbacks
    let req = '';

    let appKey = module.getAttribute('data-key');
          
    faceAge.API.getAdvisorData(async (data) => {
      // Use the data from the analysis
      //console.log('Advisor data analysis:', data);


      let products = await getAdvisorData(data, appKey);
      req = products?.data?.req.key;
      faceAge.API.setCustomProducts(products?.data?.products ?? []);


      faceAge.API.getActiveSelections(async (dataActive) => {
        //console.log('Quiz active selection data:', dataActive);
        await setSelectionsData(req, {activeSelections : dataActive, analysis: data?.analysis ?? null, products: products?.data?.products ?? []}, appKey);
      });

    });

    faceAge.onAddToCart( async (data) => {
      // Retrieve product information when a user clicks add to cart
      //console.log('User clicked add to cart:', data);

      if(data){

        let productIds = [];
        let productsToAdd = [];
        data.map(item => {

          const productId = item?.variable?.variables ? item?.variable?.variables : item?.id;
          productIds.push({id : item?.id , variable: (item?.variable?.variables ? item?.variable?.variables : null)});
          const numericId = productId.split('/').pop();
          productsToAdd.push({ id: numericId, quantity: 1, properties: {_faceAge : 'pr_analyzer'} });

        });

        if(productsToAdd.length >= 1){
          if(productsToAdd.length >= 6){
            const chunks = chunkArray(productsToAdd, 5);

            for (const chunk of chunks) {
              await addToCart(chunk);
            }
          }else{
            await addToCart(productsToAdd);
          }
        }

        if(req)
          await setAddToCartData(req, productIds, appKey);
      }
    });

    faceAge.onClickProduct((product) => {
      // Retrieve product details when a user clicks on a product
      //console.log('User clicked on product info:', product);
    });

    faceAge.onClickProblem((key) => {
      // Get user status and information when they click on a problem
      //console.log('User clicked on problem:', key);
    });

    faceAge.onDisplayProducts((data) => {
      // Display product information when the product list is shown
      console.log('Display Products:', data);
    });

    faceAge.onDisplayRoutines((data) => {
      // Display routine information when the routine list is shown
      console.log('Display Routines:', data);
    });

    faceAge.onCheckout((data) => {
      // Trigger when the user clicks the checkout button
      console.log('User clicked checkout');

      const checkoutUrl = '/checkout';
      window.location.href = checkoutUrl;
    });


  }

}

const currencySymbols = {
  'CAD': '$',
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'AUD': '$',
  'NZD': '$',
  'JPY': '¥',
  'CNY': '¥',
  'CHF': 'CHF',
  'SEK': 'kr',
  'NOK': 'kr',
  'DKK': 'kr',
  'SGD': '$',
  'HKD': '$',
  'RUB': '₽',
  'INR': '₹',
  'MXN': '$',
  'BRL': 'R$',
  'ZAR': 'R',
  'THB': '฿',
  'MYR': 'RM',
  'IDR': 'Rp',
  'ARS': '$',
  'TWD': 'NT$',
  'CLP': '$',
  'COP': '$',
  'PKR': '₨',
  'VND': '₫',
  'NPR': 'Rs',
  'BWP': 'P',
  'GHS': '₵',
  'BBD': '$',
  'FJD': '$',
  'AED': 'AED',
  'JMD': '$',
  'XOF': 'CFA',
  'TZS': 'TSh',
  'LKR': 'Rs',
  'MUR': 'Rs',
  'SCR': '₨',
  'BND': '$',
};

async function getAdvisorData(data, key) {

  const host = isProxy;

  const response = await fetch(`/apps/` + (host ? JSON.parse(host).data : 'getAdvisorData'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: 'findProduct',
      key: key,
      analysis: data?.analysis ? data?.analysis.map(item => {return {key: item.key, number: item.number, format: item.format, title: (item?.titleTr || item?.title)}}) : [],
      activeSelections: data?.activeSelections
    })
  });

  return await response.json();
}

async function setSelectionsData(req, data, key) {
  const host = isProxy;

  const response = await fetch(`/apps/` + (host ? JSON.parse(host).data : 'getAdvisorData'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: 'selectionsData',
      key: key,
      req: req,
      analysis: data?.analysis ? data?.analysis.map(item => {return {key: item.key, number: item.number, format: item.format, title: (item?.titleTr || item?.title)}}) : [],
      activeSelections: data?.activeSelections,
      products: data?.products
    })
  });

  return await response.json();
}

async function setAddToCartData(req, ids, key) {
  const host = isProxy;

  const response = await fetch(`/apps/` + (host ? JSON.parse(host).data : 'getAdvisorData'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: 'addToCart',
      key: key,
      req: req,
      productIds: ids
    })
  });

  return await response.json();
}

async function updateCartCount() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(cart => {
        const cartCountElement = document.querySelector('.cart-count');
        if (cartCountElement) {
          cartCountElement.textContent = cart.item_count;
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
}

async function addToCart(productsToAdd) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(productsToAdd.length > 1 ? {items: productsToAdd} : productsToAdd[0])
  })
      .then(async response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        // update cart bubble counter
        console.log('Update cart bubble counter');
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
}

const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};
